document.addEventListener('DOMContentLoaded', () => {
    const videoSection = document.querySelector('.video');
    if (!videoSection) return;
  
    const video = videoSection.querySelector('video');
    const playButton = videoSection.querySelector('.video-play__button');
    const playIcon = playButton.querySelector('.play-icon');
    const pauseIcon = playButton.querySelector('.pause-icon');
  
    if (!video || !playButton || !playIcon || !pauseIcon) return;
  
    let isPlaying = false;
  
    function togglePlayPause() {
      if (video.paused) {
        video.play()
          .then(() => {
            isPlaying = true;
            playIcon.classList.add('hidden');
            pauseIcon.classList.remove('hidden');
          })
          .catch(error => {
            console.error('Error playing video:', error);
          });
      } else {
        video.pause();
        isPlaying = false;
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
      }
    }
  
    playButton.addEventListener('click', togglePlayPause);
  
    video.addEventListener('ended', () => {
      isPlaying = false;
      playIcon.classList.remove('hidden');
      pauseIcon.classList.add('hidden');
      video.currentTime = 0;
    });
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !video.paused) {
            video.pause();
            isPlaying = false;
            playIcon.classList.remove('hidden');
            pauseIcon.classList.add('hidden');
          }
        });
      },
      { threshold: 0.3 }
    );
  
    observer.observe(videoSection);
  
    return () => {
      observer.disconnect();
      video.pause();
    };
  });